// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PhoneTwoToneSvg from "@ant-design/icons-svg/es/asn/PhoneTwoTone";
import AntdIcon from '../components/AntdIcon';

var PhoneTwoTone = function PhoneTwoTone(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: PhoneTwoToneSvg
  }));
};

PhoneTwoTone.displayName = 'PhoneTwoTone';
export default React.forwardRef(PhoneTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/PhoneTwoTone.js
// module id = 1557
// module chunks = 0